import { transformDateField } from '../../../utils';
export default {
    name: 'DateRender',
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: String,
            default: null,
        },
        locale: {
            type: String,
            default: 'en',
        },
    },
    computed: {
        formattedValue() {
            return transformDateField(this.value, this.locale);
        },
    },
};
